export const CREDITS_IMPORT_WIZARD_NAMESPACE = 'credits-import';

export const CREDITS_IMPORT_STEPS = {
  CREDIT_TYPE_SELECTION: 'credit-type-selection',
  FILE_IMPORT: 'file-import',
} as const;
